import axios from "axios";

const state = {
  lstCostos: [],
  lstOpciones: [],
  lstMercaderia: [],
  lstConfig: [],
  maximoValorOpcion: {},
};
const mutations = {
  SET_COSTOS(state, data) {
    state.lstCostos = data;
  },
  SET_OPCIONES(state, data) {
    state.lstOpciones = data;
  },
  SET_MERCADERIA(state, data) {
    state.lstMercaderia = data;
  },
  SET_CONFIGT_MERCADERIA(state, data) {
    state.lstConfig = data;
  },
  SET_MAXIMO_VALOR_OPCION(state, data) {
    state.maximoValorOpcion = data;
  },
};
const actions = {
  async cargarCostos({ commit }, data) {
    try {
      const config = {
        method: "post",
        url: process.env.VUE_APP_URL_MAIN + "calc/montos",
        headers: {
          "auth-token": sessionStorage.getItem("auth-token"),
          "Content-Type": "application/json",
        },
        params: data,
      };

      const response = await axios(config);
      const res = response.data;

      if (res.estadoflag) {
        const cotizaciones = res.data.map((c) => ({
          ...c,
          mostrarDetalle: false,
        }));
        sessionStorage.setItem("cotizaciones", JSON.stringify(cotizaciones));
        
        sessionStorage.setItem("id_cotizacion", res.data[0].id_cotizacion);
        commit("SET_COSTOS", cotizaciones);
      }
      return res;
    } catch (error) {
      console.log(error);
      return {
        estadoflag: false,
        mensaje:
          (error.response && error.response.data && error.response.data.mensaje) ||
          "No se pudo generar la cotización. Inténtalo nuevamente.",
      };
    }
  },
  async cargarOpciones({ commit }, data) {
    try {
      const config = {
        method: "get",
        url: process.env.VUE_APP_URL_MAIN + "calc/opciones",
        params: data,
        headers: {
          "auth-token": sessionStorage.getItem("auth-token"),
          "Content-Type": "application/json",
        },
        params: data,
      };

      const response = await axios(config);
      const res = response.data;

      if (res.estadoflag) {
        const opciones = res.data.map((c) => ({
          ...c,
          mostrarDetalle: false,
        }));
        sessionStorage.setItem("opciones", JSON.stringify(opciones));
        commit("SET_OPCIONES", opciones);
      }
    } catch (error) {
      console.log(error);
    }
  },
  async obtenerMaximoValorOpcion({ commit }, data) {
    let listado = [];
    var config = {
      method: "get",
      url: process.env.VUE_APP_URL_MAIN + "calc/obtener_maximo_valor_opcion",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      params: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          commit("SET_MAXIMO_VALOR_OPCION", data.data[0]);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    return listado;
  },
  async cargarMercancia({ commit }, data) {
    let listado = [];
    var config = {
      method: "get",
      url: process.env.VUE_APP_URL_MAIN + "calc/cargar/mercancia",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      params: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          commit("SET_MERCADERIA", data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    return listado;
  },
  async cargarConfig({ commit }, data) {
    let listado = [];
    var config = {
      method: "get",
      url: process.env.VUE_APP_URL_MAIN + "calc/cargar/config",
      headers: {
        "auth-token": sessionStorage.getItem("auth-token"),
        "Content-Type": "application/json",
      },
      params: data,
    };
    await axios(config)
      .then(function (response) {
        let data = response.data;
        if (data.estadoflag) {
          commit("SET_CONFIGT_MERCADERIA", data.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    return listado;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
